export default __webpack_public_path__ + "static/media/40g.56f34854.svg";